import { api_107_json_request } from "../1.07/json";
import { GSAPI_CALL_NAME } from "../Csi/csi.types";
import { params } from "../utils/params";

/**
 * RGS API Base Class
 */
export class api_base {
    public readonly API_VERSIONS: string[] = [];
    
    protected readonly LOG_LEVEL: number = 0;
    protected readonly LOG_PREFIX: string = '*** RGS: ';

    public gameKey: string = "";

    public gameUID: string = "";

    protected params: params;

    protected lastCall: GSAPI_CALL_NAME | null = null;

    protected bet!: object;

    protected serverBaseURL: string = "";

    protected error: any = { code: null, text: null };

    public request: api_107_json_request | null = null;

    protected serverHost: string = "";

    /**
     * Constructor
     * @param gameKey Game Key
     * @param gameUID Game UID
     * @param params Launching params
     */
    constructor(gameKey: string, gameUID: string, params: params) {
        this.gameKey = gameKey;
        this.gameUID = gameUID;
        this.params = params;
        
        this.serverBaseURL = this.getServerBaseURL();
    };

    protected getServerBaseURL(): string {
        return this.params.gsp + "//" + this.params.serverHost + "/system/gameclient/ne/" + this.params.serverVersion + "/";
    }

    /**
     * Write a log
     * @param args 
     */
    protected log(level: number, ...args: any[]): void {
        // Check the log level
        if (level <= this.LOG_LEVEL) {
            // 1. Convert args to a normal array
            args = Array.prototype.slice.call(arguments, 1);
            // 2. Prepend log prefix log string
            args.unshift(this.LOG_PREFIX);
            // 3. Pass along arguments to console.log
            console.log.apply(console, args);
        }
        // add support for error level
        if (level === 3) {
            // 1. Convert args to a normal array
            args = Array.prototype.slice.call(arguments, 1);
            // 2. Prepend log prefix log string
            args.unshift(this.LOG_PREFIX);
            // 3. Pass along arguments to console.log
            console.error.apply(console, args);
        }
    }

    /**
     * Init RGS API
     * @param requestCall    API request Call Name
     * @param requestData    API request Data
     */
    public init(requestCall: GSAPI_CALL_NAME, requestData: any): void {
        this.error.code = 0;
        this.error.text = null;
        
        // Check of RGS call protocol
        switch (requestCall) {
            case GSAPI_CALL_NAME.REG_STEP: {
                if ((this.lastCall !== GSAPI_CALL_NAME.REG_ROUND)
                && (this.lastCall !== GSAPI_CALL_NAME.END_STEP)
                && (this.lastCall !== GSAPI_CALL_NAME.GET_DATA)) {
                    this.log(3, 'Invalid RGS Call - Request (' + requestCall + ') - Last Call (' + this.lastCall + ')');
                }
            }
                break;
        }
        // NOTE: the call 'log event' can be invoked at any time for this is not stored
        this.lastCall = (requestCall !== GSAPI_CALL_NAME.LOG_EVENT && requestCall !== GSAPI_CALL_NAME.GENERIC) ? requestCall : this.lastCall;
        
        this.request = requestData;
    }

    /**
     * Check API Version
     */
    protected checkAPIVersion() {
        // NOTA: si utilizzano i primi 4 caratteri al fine di gestire eventuali versioni di test/sviluppo (ad esempio 1.07-DEV)
        let serverAPI     = this.params.serverAPI.substr(0,4);
        let serverVersion = this.params.serverVersion.substr(0,4);
        if (this.API_VERSIONS.indexOf(serverAPI) == -1) {
            throw new Error("Server API mismatch");
        }
        if (this.API_VERSIONS.indexOf(serverVersion) == -1) {
            throw new Error("Server Version mismatch");
        }

        if( this.params.serverHost === ""){
            this.serverHost = window.location.hostname;
        }
        else{
            this.serverHost = this.params.serverHost;
        }

        this.serverBaseURL = this.params.gsp + "//" + this.serverHost + "/system/gameclient/ne/" + this.params.serverVersion + "/";
    };

    protected setEncodeParam(param: string): string {
        return (param) ? encodeURIComponent(param) : "";
    }

    public getEncodedLaunchingUrl(): string {
        return this.setEncodeParam(this.params.location);
    }
}